module.exports = __WEBPACK_EXTERNAL_MODULE_18__;


//////////////////
// WEBPACK FOOTER
// external {"root":"jspdf","commonjs2":"jspdf","commonjs":"jspdf","amd":"jspdf"}
// module id = 18
// module chunks = 0